import html2pdf from "html2pdf.js";

export const PAYMENT_METHODS = ["Efectivo", "SINPE Móvil", "Transferencia", "Tarjeta", "Crédito"];

const nf = new Intl.NumberFormat("es-CR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const money = (v, cur = "CRC") => `${cur === "USD" ? "$" : "₡"}${nf.format(Number(v) || 0)}`;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const addDays = (iso, n) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// Mismo cálculo que el servidor (backend/server.py: calc_totals)
export const calcTotals = (items, globalDiscount, iva) => {
  let subtotal = 0, lineDisc = 0, taxable = 0;
  const gdp = Number(globalDiscount) || 0;
  items.forEach((it) => {
    const gross = (Number(it.qty) || 0) * (Number(it.price) || 0);
    const ld = (gross * (Number(it.discount) || 0)) / 100;
    subtotal += gross;
    lineDisc += ld;
    if (it.taxable !== false) taxable += gross - ld;
  });
  const after = subtotal - lineDisc;
  const gd = (after * gdp) / 100;
  const tax = (taxable * (1 - gdp / 100) * (Number(iva) || 0)) / 100;
  return { subtotal: round2(subtotal), discount: round2(lineDisc + gd), tax: round2(tax), total: round2(after - gd + tax) };
};

export const lineTotal = (it) => {
  const gross = (Number(it.qty) || 0) * (Number(it.price) || 0);
  return round2(gross - (gross * (Number(it.discount) || 0)) / 100);
};

// Reduce y convierte una imagen a dataURL para guardarla en el servidor
export const fileToDataUrl = (file, max = 500) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const s = Math.min(1, max / Math.max(img.width, img.height));
        const c = document.createElement("canvas");
        c.width = Math.round(img.width * s);
        c.height = Math.round(img.height * s);
        c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
        resolve(c.toDataURL(file.type === "image/png" ? "image/png" : "image/jpeg", 0.88));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const PDF_OPTS = {
  margin: [8, 8, 8, 8],
  image: { type: "jpeg", quality: 0.96 },
  html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
  jsPDF: { unit: "mm", format: "letter", orientation: "portrait" },
  pagebreak: { mode: ["css", "legacy"], avoid: "tr" },
};

export const exportPdf = (el, filename) => html2pdf().set({ ...PDF_OPTS, filename }).from(el).save();

// PDF en base64 (sin prefijo) para adjuntarlo al correo
export const pdfBase64 = async (el) => {
  const uri = await html2pdf().set(PDF_OPTS).from(el).outputPdf("datauristring");
  return uri.slice(uri.indexOf(",") + 1);
};
